"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bus = void 0;
var Bus = /** @class */ (function () {
    function Bus() {
        this.eventMap = {};
        this.subId = -1;
    }
    Bus.prototype.subscribe = function (event, callback, correlationId) {
        this.eventMap[event] = this.eventMap[event] || [];
        var token = (++this.subId).toString();
        this.eventMap[event].push({ token: token, callback: callback, options: { correlationId: correlationId } });
        return token;
    };
    Bus.prototype.publish = function (event, payload, correlationId) {
        var _this = this;
        if (!this.eventMap[event]) {
            return false;
        }
        setTimeout(function () {
            var subscribers = _this.eventMap[event];
            subscribers.forEach(function (_a) {
                var callback = _a.callback, options = _a.options;
                callback(payload, {
                    correlationId: correlationId,
                    correlates: correlationId === options.correlationId,
                });
            });
        }, 0);
        return true;
    };
    Bus.prototype.unsubscribe = function (token) {
        var found = false;
        Object.values(this.eventMap).forEach(function (subscriptions) {
            var idx = subscriptions.findIndex(function (s) { return s.token === token; });
            if (idx > -1) {
                subscriptions.splice(idx, 1);
                found = true;
            }
        });
        return found ? token : false;
    };
    return Bus;
}());
exports.Bus = Bus;
//# sourceMappingURL=bus.js.map